<script>
  import get from "lodash/get";
  import { getZoomscale } from "overline/geometry";

  import { setCanvasCtx } from "#src/extensions/canvas-viewport";
  import { drawingSrc } from "#src/api";
  import { Drawing } from "drawing";

  import markColor from "@local/extensions/drawing/mark-color.js";

  export let item;
  export let group;
  export let locations = [];

  const dpi = window.devicePixelRatio;

  const markShapes = {
    item: "hexagon",
    collection: "rectangle",
    type: "circle",
    document_note: "rectangle",
  };

  let canvas;
  let ctx;
  let width;
  let height;

  $: {
    if (canvas) {
      ctx = canvas.getContext("2d");
    }
  }
  $: {
    locations;
    width;
    height;
    canvas && ctx && render();
  }

  function getDrawingSrc(item) {
    return item.drawing && drawingSrc(item.drawing);
  }

  function render() {
    const clip = item.drawing?.clip;
    if (!clip) return;

    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;
    canvas.width = Math.ceil(width * dpi);
    canvas.height = Math.ceil(height * dpi);

    const extents = {
      xmin: 0,
      ymin: 0,
      xmax: clip.width,
      ymax: clip.height,
    };

    const cWidth = Math.ceil(width * dpi);
    const cHeight = Math.ceil(height * dpi);

    const bbox = getZoomscale(cWidth, cHeight, extents, 0);

    setCanvasCtx(ctx, bbox.zoomscale, 0, 0);

    locations.forEach((l) => {
      const { x, y } = l.position;
      const pos = { x: x - clip.x, y: -(y - clip.y) };
      const record = $group.items[l.record_id];

      if (record) {
        const inverted = record.collection_id !== item.id;
        const labelBy = record.is_collection
          ? $group.data.settings.collections_label_by
          : $group.data.settings.label_by;
        const mark = labelBy ? get(record, labelBy) : record.mark;

        const dwg = new Drawing()
          .mark(pos, mark, {
            shape: markShapes[l.record_type],
          })
          .style(markColor(record, { emphasized: true, inverted }));

        dwg.render({ ctx, annoScale: dpi / bbox.zoomscale });
      }
    });
  }
</script>

<div class="relative" bind:offsetWidth={width} bind:offsetHeight={height}>
  <img class="max-h-36 border border-gray-400" src={getDrawingSrc(item)} alt="" />
  <div class="absolute top-0 left-0 w-full h-full">
    <canvas bind:this={canvas} class="w-full h-full" />
  </div>
</div>
